"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const colors_1 = require("../../common/colors");
const native_base_1 = require("native-base");
function AppModal({ isOpen, onClose, closeButtonPosition, openAnimation = 'slide', closeAnimation = 'fade', style, children, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: isOpen, transparent: true, animationType: isOpen ? openAnimation : closeAnimation, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.background, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.container, style], ...restProps, children: [(0, jsx_runtime_1.jsx)(native_base_1.NativeBaseProvider, { children: children }), onClose && ((0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClose: onClose, verticalOffset: closeButtonPosition?.verticalOffset, horizontalOffset: closeButtonPosition?.horizontalOffset }))] }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    background: {
        backgroundColor: `${colors_1.Colors.DARK_700}CC`,
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
    },
    container: {
        backgroundColor: colors_1.Colors.NEUTRAL_75,
        padding: 24,
        borderRadius: 24,
        shadowColor: 'rgba(0, 0, 0, 0.24)',
        shadowOffset: {
            width: 0,
            height: -16,
        },
        shadowRadius: 24,
    },
});
